<template>
  <v-layout column fill-height pa-1>
    <v-layout v-if="header.length" justify-space-between align-center px-2 class="primary" style="height: 28px">       
      <span class="white--text text-uppercase caption">{{ $t(header) }}</span>
    </v-layout>
    <v-container id="topo_main" ref="topo_main" fluid fill-height class="back" pa-0>
      <v-layout fill-height pa-0>
        <v-layout column pa-0 ref="topo_main_map">
          <component
            v-if="showMap"
            :is="'location-map'"
            :mode="this.$options.name"
            :data="getData"
            :locations="getLocations"
            :mapCenter="getMapCenter"
            :mapZoom="getMapZoom"
            :editMapCenter="dialog.editMapCenter.show"
            @changeZoom="(payload) => {mapZoom = payload}"
            @changeCenter="(payload) => {dialog.editMapCenter.mapObj = payload}"
          />
        </v-layout>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import LocationMap from '@/nms/components/map/map.vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import topologyBar from '@/nms/components/map/bar.vue'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

// Типы для данных
interface LocationItem {
  $id?: string
  name?: string
  [key: string]: any
}

interface ConnectionItem {
  $id?: string
  [key: string]: any
}

interface DialogState {
  editMapCenter: {
    show: boolean
    mapObj: any | null
  }
}

type MapCenter = [number, number]

export default Vue.extend({
  name: 'MAIN_MAP',

  components: {
    scrollArea,
    LocationMap,
    loadingCircle,
    topologyBar,
  },

  props: {
    header: {
      type: String,
      default: () => ''
    },
  },

  data(): {
    dialog: DialogState
    data: Record<string, any>
    locations: LocationItem[]
    showMap: boolean
    mapCenter: MapCenter
    mapZoom: number
  } {
    return {
      dialog: {
        editMapCenter: {
          show: false,
          mapObj: null,
        }
      },
      data: {},
      locations: [],
      showMap: false,
      mapCenter: [37.617589, 55.755919],
      mapZoom: 10,
    }
  },

  computed: {
    getData(): Record<string, any> {
      return this.data
    },

    getLocations(): LocationItem[] {
      return this.locations
    },

    getMapCenter(): MapCenter {
      return this.mapCenter
    },

    getMapZoom(): number {
      return this.mapZoom
    },
  },

  watch: {
    '$store.state.topology.connections': {
      handler(newVal: ConnectionItem[]): void {
        if (!newVal) return
        this.statusSubscribe(newVal, 'map')
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadData()
      this.loadConnections()
    },

    async loadData(): Promise<void> {
      try {
        const locations$ = await this.$bridge.getObjectsByClass('location')
        
        if (locations$?.length) {
          this.locations = locations$
          this.showMap = true
          this.statusSubscribe(this.locations, 'map')
        } else {
          this.showMap = true
          await this.statusUnsubscribe('map')
        }
      } catch (error) {
        console.error(this.$options.name, 'loadData', 'smth wrong', error)
      }
    },

    loadConnections(): void {
      this.$store.dispatch('loadConnections')
    },

    editMapCenter(): void {
      this.$set(this.dialog.editMapCenter, 'show', !this.dialog.editMapCenter.show)
    },

    async statusSubscribe(arr: (LocationItem | ConnectionItem)[], group: string): Promise<void> {
      await this.statusUnsubscribe(group)
      
      this.$store.dispatch('measuresSubscribeInit', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
      
      if (arr.length) {
        arr.forEach((item: LocationItem | ConnectionItem) => {
          if (item.$id) {
            this.$store.dispatch('addStatusKey', item)
          }
        })
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    async statusUnsubscribe(group: string): Promise<void> {
      await this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },
  },
})
</script>

<style lang="css" scoped>
</style>
